module.exports = __webpack_public_path__ + "img/userMan.39d8fc58.svg";